module.exports = __webpack_public_path__ + "static/img/server.f13cf274.svg";